<template>
    <dtunes-modal :dialog="dialog" @openModal="dialog = true" @closeModal="dialog = false">
        <template v-slot:button> Suspend</template>
        <template v-slot:content>
            <v-card class="pad-10">
                <v-card-title class="d-flex justify-center">
                    <p class="text-center">SUSPEND ADMIN</p>
                </v-card-title>
                <v-card-text>

                    <v-card-title class="d-flex justify-center">
                        <p class="text-center">ARE YOU SURE YOU WANT TO SUSPEND THIS ADMIN ?</p>
                    </v-card-title>

                    <div style="background:#f7f7f7; padding:10px 10px 5px 10px">
                        <v-row>
                            <v-col cols="6">
                                <default-button @click="closeModalFunction()">Cancel</default-button>
                            </v-col>
                            <v-col cols="6">
                                <default-button :loading="loading" @click="suspendAdmin()">Confirm</default-button>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </template>
    </dtunes-modal>
</template>

<script>

// ========== IMPORT COMPONENTS =============
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

// ============ IMPORT SERVICES ===============
import { StoresService } from "@/services";

export default {
    data: () => ({
        loading: false,
        dialog: false,
    }),
    components: {
        DtunesModal,
        DefaultButton,
    },
    props: {
        details: {
            type: Object,
            required: true
        },
    },
    mounted() {
        this.id = this.details.id;
    },
    methods: {

        // ============= METHOD TO DELETE GIFTCARD ======
        async suspendAdmin() {
            try {
                this.loading = true
                const data = await StoresService.suspendAdmin(this.details.email);
                this.loading = false
                this.$store.dispatch('toast', {
                    message: `Admin Suspended sucessfully`,
                    variant: 'success'
                });
                this.dialog = false;
                this.$emit('closeModal');
                console.log(data);
            } catch (error) {
                this.loading = false
                console.log(error);
                this.$store.dispatch('toast', {
                    message: `Could not suspend admin`,
                    variant: 'error'
                });
            }
        },
        closeModalFunction() {
            this.dialog = false;
            this.$emit('closeModal');
        }
    }
};
</script>